import { Form, Input, Radio } from '@roo/roo';
import React,{ useState } from 'react';
import { Code } from './code.js'
import { Commend } from './commend.js'
import { FormHok } from '../../_components/FormHok.js';
const Field = Form.field;
const RadioGroup = Radio.Group;

export const Recommend = (props) => {
  const { values, setFieldValue, disabled } = props
  // console.log(values);
  return (
      <div  className='form-patch' style={{marginBottom:0}}>
        {/* <FormHok
          value={values}
          cols={{
            field: { span: 9 },
            label: { span: 3 }
          }}
          // handleSave={saveApplyInfo}
        >
          {({ values, validateField }) => (
           
          )}
        </FormHok> */}
         <>
              <Field
                  // required={true}
                  cols={{
                    field: { span: 12 },
                    label: { span: 0}
                  }}
                  rule={{
                    validator: (rule, value, callback) => {
                      if ([true, false].includes(value)) {
                        return callback();
                      } else {
                        callback('请选择是否被提名');
                      }
                    },
                  }}
                  // label='您是否被提名'
                  name='isNominated'
                >
                  {({ value, handleChange }) => {
                    return (
                      <RadioGroup
                        disabled={disabled}
                        value={Boolean(value)}
                        onChange={(e) => {
                          setFieldValue('isNominated',e)
                        }}
                      >
                        <Radio value={false}>推荐申报</Radio>
                        <Radio value={true}>提名申报</Radio>
                      </RadioGroup>
                    );
                  }}
                </Field>
                <RenderInfo {...props} isNominated={values.isNominated}></RenderInfo>
            </>
      </div>
  );
};
export const RenderInfo = ({ isNominated,...props}) => {
    switch (isNominated) {
      case true:
        return (
         <>
          <div className='patch-tips' style={{marginBottom:0}}>
            <div className="info" style={{paddingLeft:'18%',width:'max-content'}}>
              请确认您已收到提名邮件，在提名邮件中复制提名码填写至下方校验。若您被多人提名，请全部填写。
            </div>
          </div>
          <Code {...props}></Code>
        </>
        )
      default:
        return (
          <>
            <div className='patch-tips'>
              <div className="info">
                1. 请您与以下推荐人沟通确认，他们愿意为您申报青山科技奖提供推荐信
                <br></br>
                2. 在您填写并提交申报材料后，系统将向推荐人发送推荐邀请邮件，由推荐人提交推荐信。
              </div>
            </div>
            <Commend {...props}></Commend>
          </>)
    }
}